export default "__VITE_ASSET__996554fd__"